<template>
      <v-container>
        <v-card
        class="mx-auto">
          <v-toolbar flat color="secondary" dark>
              <v-toolbar-title>{{ this.$route.meta.title }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="deep-orange accent-3" @click="btnAdd" type="button"><v-icon left>{{icon.add}}</v-icon>Tambah</v-btn>
          </v-toolbar>
          <v-card-text>
              <v-data-table
              :options.sync="options"
              :headers="headers"
              :items="dataList"
              :server-items-length="total_data"
              :loading="data_loading"
              :search="search"
              class="elevation-1"
              dense
              >
              <template v-slot:top>
              <v-toolbar flat color="white">
                <v-dialog>
              <template v-slot:activator="{ on }">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field v-model="search"
                    label="Search"
                    single-line
                    hide-details></v-text-field>
                  </v-col>
                </v-row>
              </template>
              </v-dialog>
                </v-toolbar>
              </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    {{icon.edit}}
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteItem(item)"
                  >
                    {{icon.delete}}
                  </v-icon>
                </template>
              </v-data-table> 
          </v-card-text>
      </v-card>
    </v-container>
</template>

<script>
/* eslint-disable */
   let context;
   export default{
    name:"users.index",
    data: ()=>{
      return {
        icon:{
          add:'mdi-plus',
          edit:'mdi-pencil',
          delete:'mdi-delete'
        },
        search:"",
        total_data: 0,
        options: {
                itemsPerPage: 10,
                descending: false,
                page: 1
            },
        dataList: [],
        datas: [],
        data_loading: false,
        headers: [
          { text: 'Code', value: 'code' },
          { text: 'Name', value: 'name'},
          { text: 'Created', value: 'created_at' },
          { text: 'Actions', value: "action" ,sortable:false},
        ],
      }
    },
    watch: {
      datas: [],
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.dataList = data.items
              this.total_data = data.total
            })
        },
        deep: true,
      },
      search:async function(val){
        if(val != ''){
          await this.getDataSearch(val);
        }else{
          await this.getData();
        }
      } 
    },
    created: function () {
    },
    async mounted () {
      context=this;
      await this.getData();
    },
    methods: {

      getData () {
        context.data_loading=true;
        this.$http.get(this.$route.meta.parent+'/get').then(({data,status})=>{
            if(status===200){
              this.datas = JSON.parse(JSON.stringify(data.data));
              this.getDataFromApi().then(data => {
                this.dataList = data.items
                this.total_data = data.total
              });
            }
            context.data_loading=false;
          }
        )
        .catch(error=>{
            // alert(error);
            console.log(error)
        });
      },
      getDataSearch (val) {
          context.data_loading=true;
          this.$http.get(this.$route.meta.parent+'/get?q='+val).then(({data,status}) => {
            this.datas = JSON.parse(JSON.stringify(data.data));
            this.getDataFromApi().then(data => {
              this.dataList = data.items
              this.total_data = data.total
            });
          context.data_loading=false;
          }).catch(error=>{
            // alert(error);
            console.log(error)
        });
      },
      getDataFromApi () {
        // console.log(this.datas.length)
        this.loading = true
        return new Promise((resolve) => {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let items = this.datas;
          const total = items.length

          if (sortBy.length === 1 && sortDesc.length === 1) {
            items = items.sort((a, b) => {
              const sortA = a[sortBy[0]]
              const sortB = b[sortBy[0]]

              if (sortDesc[0]) {
                if (sortA < sortB) return 1
                if (sortA > sortB) return -1
                return 0
              } else {
                if (sortA < sortB) return -1
                if (sortA > sortB) return 1
                return 0
              }
            })
          }

          if (itemsPerPage > 0) {
            items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
          }

          setTimeout(() => {
            this.loading = false
            resolve({
              items,
              total,
            })
          }, 1000)
        })
      },

      

      editItem:(item)=>{
        context.$router.push('/'+context.$route.meta.parent+'/edit/'+item.id);
      },

      deleteItem:async (item)=>{
        let conf=confirm("Apakah anda yakin akan menghapus "+item.name+" dari database?");
        let index=context.dataList.indexOf(item);

        if(conf){
          let payload={
            id:item.id
          }
          let success_text="Berhasil menghapus "+item.name+" dari database";
          await context.$http
          .delete(context.$route.meta.parent+'/delete',{data:payload})
          .then(response=>{
              if(response.status===200){
                  context.$notify({
                      group:response.data.data.valid,
                      title:response.data.data.valid.toUpperCase()+" NOTIFICATION",
                      text:response.data.success
                  });
                  // console.log(response.data);
                context.dataList.splice(1,1);
              }
          })
          .catch(err=>{
                console.log(err);
                context.$notify({
                    group:"error",
                    title:"Error Notification",
                    text:"Terjadi kesalahan pada client"
                })
            });
        }
      },

      search_user:()=>{
          context.data_loading=true;
          context.$http.get('users')
      },

      btnAdd () {
        this.$router.push('/'+context.$route.meta.parent+'/add')
      }
    },
}
</script>